import { type EmojiId, type Token } from '@app/client';

export interface ReturnLinkParams {
    returnLink?: string;
    actionType: 'connect' | 'manage' | 'cancel';
    eid?: EmojiId;
    refreshToken?: Token['refresh_token'];
}

export function getReturnLink(returnLinkParams: ReturnLinkParams) {
    const { returnLink = '', actionType, eid = '', refreshToken = '' } = returnLinkParams;
    const regex = /{([^}]+)}/g;
    if (!regex.test(returnLink)) {
        const hasParamStart = Boolean(returnLink?.indexOf('?') != -1);
        return `${returnLink}${hasParamStart ? '&' : '?'}action=${actionType}&eid=${eid}&refresh_token=${refreshToken}`;
    }
    return returnLink.replace(regex, (match, placeholder) => {
        return returnLinkParams[placeholder.trim()] ?? '';
    });
}
